import { useStore } from 'zustand';
import { ContentMetadataState } from '@/player-config/src/types/content-metadata-store-types';
import {
  ContentMetadataStoreFactoryType,
  createContentMetadataStore
} from '@/player-config/src/stores/contentMetadataStoreFactory';

const contentMetadataStore: ContentMetadataStoreFactoryType = createContentMetadataStore();

function useContentMetadataStoreHook<U>(selector: (state: ContentMetadataState) => U): U {
  return useStore(contentMetadataStore, selector);
}

export const useContentMetadataStore = Object.assign(useContentMetadataStoreHook, contentMetadataStore);
